/* eslint-disable no-shadow */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
/* eslint-disable indent */
import React from 'react';
import moment from 'moment';

// Local imports
import Button from 'shared/components/button/Button';

// API imports
import {
  ExportChannelArchitectureGradeAPI,
  ImportGradeArchitectureAPI,
  GetGradeArchitectureAPI,
} from 'api';

// Custom hooks
import useStore from 'store/AccountStore';

// Third-party libraries
import { OpSchedulerNext } from 'op2mise-react-widgets';

// Utility functions
import { formatDateWithMoment } from 'utils';

// Modals
import { ImportComponent } from './modals/ImportComponent';
import ModifyGradingAndMinutage from './modals/ModifyGradingAndMinutage';

// Styles
import './ChannelArchitecture.css';

import SchedulerHeaderActions from './components/SchedulerHeaderActions';
import { GradingActionTypes } from './reducers/grading.reducer';
import { getWeeklyEventDate } from './utils/eventAdapter';
import SchedulerDayHeader from './components/SchedulerDayHeader';
import { GRADING_COLORS } from './ChannelArchitecture.d';

export function CAGrading({
  canUndo,
  channelInfo,
  dispatchGrading,
  endDate,
  grading,
  handleConstructGridData,
  handleGetEventDate,
  handleSaveGradeArchitecture,
  headerComponent,
  isDirty,
  setIsDirty,
  startDate,
  undoHistoryLength,
}) {
  const { user } = useStore((state) => state);
  const [openForm, setOpenForm] = React.useState(true);
  const [isLoading, setIsLoading] = React.useState(false);
  const { channelId, channelName } = channelInfo;
  const [selectedSchedule, setSelectedSchedule] = React.useState({});
  const [isDialogOpen, setIsDialogOpen] = React.useState(false);

  // Getting date range of today and tomorrow
  // NOTE: Use addDaysToDate from date.utils.js
  const tomorrow = moment().add(1, 'days').toDate();

  const period = `${formatDateWithMoment(
    new Date().toDateString(),
  )} - ${formatDateWithMoment(tomorrow)}`;

  const handleOnExport = () => {
    if (grading.length) {
      ExportChannelArchitectureGradeAPI({
        queryParams: { channelId },
        onSuccess: (res) => {
          const { organisationName } = user;
          let exportDate = new Date();
          const exportedDateString =
            String(exportDate.getDate()).padStart(2, '0') +
            String(exportDate.getMonth() + 1).padStart(2, '0') +
            exportDate.getFullYear().toString();
          const fileName = `${organisationName}_op2mise_channel_architecture_grading_export_${channelName}_${exportedDateString}.xlsx`;
          const blob = new Blob([res], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          saveAs(blob, fileName);
        },
      });
    }
  };

  const handleOnImport = () => {
    setOpenForm('IMPORT');
  };

  const handleOnSlotModified = (event) => {
    const record = event.extendedProps;
    setSelectedSchedule({
      ...record,
      startTime: handleGetEventDate(record, 'startTime'),
      endTime: handleGetEventDate(record, 'endTime'),
    });
    setIsDialogOpen(true);
  };

  const handleUpdateGrade = (newGrade) => {
    const record = grading.find(({ id }) => id === selectedSchedule.id);

    if (!record) return;

    dispatchGrading({
      actionType: GradingActionTypes.UPDATE,
      payload: {
        record: {
          ...record,
          grade: newGrade,
        },
      },
    });
    setIsDirty(true);
  };

  const schedulerEvents = React.useMemo(
    () =>
      grading.map((record) => ({
        id: record.id,
        title: String(record.grade),
        start: getWeeklyEventDate(record.dayOfWeek, record.week, record.startTime),
        end: getWeeklyEventDate(record.dayOfWeek, record.week, record.endTime),
        color: GRADING_COLORS[record.grade],
        contrastColor: '#FAFAFA',
        extendedProps: record,
      })),
    [grading],
  );

  const handleUndo = () => {
    if (!canUndo) return;
    dispatchGrading({ actionType: GradingActionTypes.UNDO });
    setIsDirty(undoHistoryLength > 1);
  };

  React.useEffect(() => {
    setIsDialogOpen(false);
  }, []);

  React.useEffect(() => {
    if (channelId) {
      GetGradeArchitectureAPI({
        queryParams: { channelId },
        onSuccess: (response) => {
          const validGrades = response.filter((schedule) => schedule.grade);
          dispatchGrading({
            actionType: GradingActionTypes.LOAD,
            payload: {
              records: handleConstructGridData(validGrades, true),
            },
          });
        },
        setLoader: setIsLoading,
      });
    }
  }, [channelId, handleConstructGridData, dispatchGrading]);

  return (
    <>
      {openForm === 'IMPORT' && (
        <ImportComponent
          closeModal={() => setOpenForm(false)}
          setIsDirty={setIsDirty}
          scheduleInfo={{ ...channelInfo, period }}
          schedulerData={{
            schedules: grading,
            period: { startTime: startDate, endTime: endDate },
            scheduleInfo: {
              ...channelInfo,
              period,
            },
          }}
          sampleTemplate="gradeImportTemplate"
          importResultColumns={[
            {
              field: 'dayOfWeek',
              headerText: 'Day of Week',
            },
            {
              field: 'startTime',
              headerText: 'Start Time',
            },
            {
              field: 'endTime',
              headerText: 'End Time',
            },
            {
              field: 'grade',
              headerText: 'Grade',
            },
          ]}
          importResultFileTitle="grade_import_result"
          handleOnImportApi={ImportGradeArchitectureAPI}
          dataExists="gradeMinutageArchitectureExist"
          dataModel="gradeMinutageArchitectureModel"
          fileError="gradeMinutageArchitectureError"
          setSchedules={(data) => {
            if (data.length) {
              const importedData = handleConstructGridData(data, true);
              dispatchGrading({
                actionType: GradingActionTypes.IMPORT,
                payload: { records: importedData },
              });
              setIsDirty(true);
              setIsLoading(false);
            }
          }}
        />
      )}
      {channelId === 0 && !channelName ? null : (
        <OpSchedulerNext
          contextMenu={{
            items: [
              {
                key: 'modify',
                label: 'Modify',
                iconCss: 'e-icons e-edit',
                onClick: (context) => handleOnSlotModified(context.event),
              },
            ],
          }}
          dayHeaderContent={(args) => <SchedulerDayHeader {...args} />}
          eventContent={(eventInfo) => (
            <div className="ca-grading-event">
              <span>{eventInfo.event.extendedProps.grade}</span>
            </div>
          )}
          eventDurationEditable={false}
          events={schedulerEvents}
          eventStartEditable={false}
          eventUpdateEnabled={false}
          header={{
            left: () => headerComponent,
            right: () => (
              <SchedulerHeaderActions
                showAdd={false}
                onUndo={handleUndo}
                canUndo={canUndo}
                onImport={handleOnImport}
                onExport={handleOnExport}
              />
            ),
          }}
          initialView="channelArchitectureView"
          isBroadcastClock={user?.clockType === 'Broadcast'}
          isLoading={isLoading}
          onEventDoubleClick={handleOnSlotModified}
          tooltip="off"
          views={{
            channelArchitectureView: {
              type: 'timeGridWeek',
              duration: { days: 7 },
              dateAlignment: 'week',
              firstDay: 1,
            },
          }}
        />
      )}

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '15px' }}>
        <Button
          text="Save"
          onClick={() => handleSaveGradeArchitecture(grading)}
          disabled={!isDirty}
        />
      </div>

      {isDialogOpen && (
        <ModifyGradingAndMinutage
          isOpen={isDialogOpen}
          closeModal={() => setIsDialogOpen(false)}
          handleUpdate={handleUpdateGrade}
          schedule={selectedSchedule}
          type="grade"
        />
      )}
    </>
  );
}

export default CAGrading;
